import { useEffect } from 'react'
import { PINNED_FILTERS_STORAGE_KEY } from '../config'
import type { PinnableConsignmentFilterKey } from './types'
import { usePinnedFiltersSelectors } from './use-pinned-filters-store'

export const useInitializeDefaultPinnedFilters = () => {
  const { setPinnedFilters } = usePinnedFiltersSelectors()

  useEffect(() => {
    const storedValue = localStorage.getItem(PINNED_FILTERS_STORAGE_KEY)
    if (storedValue !== null) return

    const defaultPinnedFilters: PinnableConsignmentFilterKey[] = ['status']
    setPinnedFilters(defaultPinnedFilters)
  }, [setPinnedFilters])
}
